import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';

import { BulletList } from 'components/ExpertSearch/components/BulletList/BulletList';
import { MailHotline } from 'components/ExpertSearch/components/MailHotline/MailHotline';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

export const Bezugsanschluss = () => {
  return (
    <div className="expert-page einspeiseranschluss">
      <div className="expert-page-content-stage-text">
        <PageTitleSection title="Bezugsanschluss" notFramed />
        <MailHotline>
          <p>
            Postfach:{' '}
            <a href="mailto:bezugsanschluss@lew-verteilnetz.de">
              bezugsanschluss@lew-verteilnetz.de
            </a>
          </p>

          <p>Hotline: 0821/328-2740</p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>
                Statusanfragen zu Aufträgen bei Anlagenveränderungen mit bestehendem Anschluss
              </li>
              <ul>
                <li>z.B. Zählerentfernungen, Zugang einer Wärmepumpe oder Ladeeinrichtung, etc.</li>
                <li>
                  Bei Status „Abgeschlossen“ und Fragen zur Zählermontage bitte direkt an den
                  Zählerkontakt wenden
                </li>
              </ul>
              <li>Fragen zur aktuell vertraglich vereinbarten Netzanschlussleistung BKZ</li>
              <li>
                Fragen zu abgelehnten Aufträgen bei Anlagenveränderung mit bestehendem Anschluss
              </li>
              <ul>
                <li>z.B. unvollständige Unterlagen, fehlende Angaben, technische Ablehnungen</li>
                <li>Bitte die Ablehnungsbegründung prüfen und ggf. Auftrag anpassen</li>
              </ul>
              <li>Anmeldung von Power to Heat Anlagen (Messkonzept MK C3)</li>
              <li>Altvorgänge im IPN die auf „Zentrale Einheit“ stehen</li>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht zum Bezugsanschluss"
          items={
            <>
              <li>Fragen rund um die Einspeisung</li>
              <li>Abgelaufener QR-Code bei Zählermontagen/Demontagen/Auswechselungen</li>
              <li>Fragen zu pauschalierten Leistungen (siehe Folie dezentrale Netzbetrieb)</li>
              <li>Terminabstimmungen zu Zählermontagen</li>
              <li>Fragen zur Montageberechtigung von Zählern</li>
              <li>
                Fragen zum Umgang mit iConnect – siehe Klickanleitungen
                (https://www.lew-verteilnetz.de/lew-verteilnetz/fuer-elektroinstallateure/e-learning#bezug)
              </li>
            </>
          }
        />
      </div>
    </div>
  );
};
MapTo('e-fix/components/content/bezugsanschluss')(Bezugsanschluss);
